<template>
  <v-row align="center" justify="center">
    <v-col cols="6" class="mx-auto" v-if="$store.state.accounts.retrieveLoader">
      <v-boilerplate type="card-heading" />
      <v-skeleton-loader class="mt-5" transition="fade-transition" type="card-heading" />
    </v-col>
    <template v-else>
      <v-col cols="6">
        <v-hover class="mb-4" v-for="d in accountsList" :key="d.id" v-slot:default="{ hover }" open-delay="200">
          <v-card :class="{'background' : hover }" @click="setAccount(d)" :ripple="false">
            <v-card-text class="pa-3">
              <v-list class="transparent">
                <v-list-item class="my-1">
                  <v-list-item-title class="body-1 text--secondary font-weight-medium">{{d.name}}</v-list-item-title>
                  <v-list-item-icon><v-icon color="primary">mdi-chevron-right</v-icon></v-list-item-icon>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-hover>
        <v-btn :to="{name: 'AccountSetup'}" :loading="$store.state.accounts.createLoader" outlined color="secondary" width="100%" :ripple="false">Crear una nueva organización</v-btn>
      </v-col>
    </template>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
export default {
  inject: ['theme'],
  components: {
    VBoilerplate: {
      functional: true,
      render (h, { data, props, children }) {
        return h('v-skeleton-loader', {
          ...data,
          props: {
            boilerplate: true,
            elevation: 2,
            ...props
          }
        }, children)
      }
    }
  },
  data: () => ({ }),
  computed: mapState({
    accountsCount: state => state.accounts.accountsCount,
    accountsList: state => state.accounts.accountsList
  }),
  created () {
    this.$store.dispatch('accounts/LIST', {
      resource: 'accounts'
    })
    .then(() => {
      if (!this.accountsCount) {
        this.$router.push({ name: 'AccountOnboarding' })
      }
    })
  },
  methods: {
    setAccount (account) {
      /**
       * runs group
       * it runs as long as the env is production
       */
      if (process.env.NODE_ENV === 'production') {
        const traits = {
          name: account.name,
          tax_id: account.tax_id
        }

        this.$analytics.group(account.id, traits)
      }

      this.$store.dispatch('auth/SET_ACCOUNT', account)
    }
  }
}
</script>